// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MobileCompactCallView__container-d825e5 {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
}

.MobileCompactCallView__compact-call-view-container-dec306 {
  width: 100%;
  height: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: row;
  position: relative;
  background-color: var(--addition-80);
}

.MobileCompactCallView__group-video-call-view-c25a04 {
  width: 100%;
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: 72px calc(var(--app-height) - 148px) 76px;
}

.MobileCompactCallView__members-panel-container-c56a69 {
  width: 100%;
  overflow: hidden;
}`, "",{"version":3,"sources":["webpack://./../../packages/call/src/CallView/MobileCompactCallView/MobileCompactCallView.styles.m.css"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,oCAAA;AACF;;AAEA;EACE,WAAA;EACA,aAAA;EACA,0BAAA;EACA,6DAAA;AACF;;AAEA;EACE,WAAA;EACA,gBAAA;AACF","sourcesContent":[".container {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 1;\n}\n\n.compact-call-view-container {\n  width: 100%;\n  height: 100%;\n  overflow: hidden;\n  display: flex;\n  flex-direction: row;\n  position: relative;\n  background-color: var(--addition-80);\n}\n\n.group-video-call-view {\n  width: 100%;\n  display: grid;\n  grid-template-columns: 1fr;\n  grid-template-rows: 72px calc(var(--app-height) - 148px) 76px;\n}\n\n.members-panel-container {\n  width: 100%;\n  overflow: hidden;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `MobileCompactCallView__container-d825e5`,
	"compact-call-view-container": `MobileCompactCallView__compact-call-view-container-dec306`,
	"compactCallViewContainer": `MobileCompactCallView__compact-call-view-container-dec306`,
	"group-video-call-view": `MobileCompactCallView__group-video-call-view-c25a04`,
	"groupVideoCallView": `MobileCompactCallView__group-video-call-view-c25a04`,
	"members-panel-container": `MobileCompactCallView__members-panel-container-c56a69`,
	"membersPanelContainer": `MobileCompactCallView__members-panel-container-c56a69`
};
module.exports = ___CSS_LOADER_EXPORT___;
